export const CoreRoutes = {
    home: '/',
    signIn: '/signin',
    signUp: '/signup',
    imprint: '/imprint'
} as const;
